import { useLocalization } from "@fluent/react";
import { ContentCard, Select } from "@narmi/design_system";
import { modules } from "byzantine";

const { useColorModeContrast, useIsAccessibilityModesEnabled } =
  modules.userAccessibilityPreferences;

const AccessibilityPreferencesCard = () => {
  const { l10n } = useLocalization();
  const isEnabled = useIsAccessibilityModesEnabled();
  const colorModeContrast = useColorModeContrast();

  if (!isEnabled) {
    return null;
  }

  return (
    <ContentCard kind="elevated">
      <h4 className="fontFamily--default fontSize--heading4 margin--bottom">
        {l10n.getString("heading-accessibility-preferences")}
      </h4>
      <Select
        label={l10n.getString("label-contrast-preference")}
        value={colorModeContrast.preference}
        onChange={(value: string) => {
          colorModeContrast.setColorModeContrast(
            value as "system" | "less" | "more"
          );
        }}
      >
        <Select.Item value="system">
          <div className="padding--y--xs">
            {l10n.getString("option-contrast-system-default")}
            <div className="fontSize--s fontColor--secondary">
              {l10n.getString("option-contrast-system-default-desc")}
            </div>
          </div>
        </Select.Item>
        <Select.Item value="less">
          <div className="padding--y--xs">
            {l10n.getString("option-contrast-standard")}
            <div className="fontSize--s fontColor--secondary">
              {l10n.getString("option-contrast-standard-desc")}
            </div>
          </div>
        </Select.Item>
        <Select.Item value="more">
          <div className="padding--y--xs">
            {l10n.getString("option-contrast-high")}
            <div className="fontSize--s fontColor--secondary">
              {l10n.getString("option-contrast-high-description")}
            </div>
          </div>
        </Select.Item>
      </Select>
    </ContentCard>
  );
};

export default AccessibilityPreferencesCard;
